<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar left-text="返回" fixed title="商户列表" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <!--导航栏 end-->
    <!-- 搜索 -->
    <van-search
      v-model="keyword"
      show-action
      placeholder="请输入商户名称"
      @search="onSearch"
      @cancel="onCancel"
    />
    <!-- 搜索end -->
    <!-- 列表 start-->
    <van-grid :column-num="3" :border="false">
      <van-grid-item text="商户编号" />
      <van-grid-item text="商户名称" />
      <van-grid-item text="是否审核" />
    </van-grid>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="init">
      <van-cell v-for="item in list" :key="item.merchant_id">
        <van-grid :column-num="3" :border="false">
          <van-grid-item :text="item.merchant_num" @click="merchant_info(item.merchant_id)" />
          <van-grid-item :text="item.bse_lice_nm" @click="merchant_info(item.merchant_id)" />
          <van-grid-item v-if="item.merchant_status == 2">
            <span>已驳回</span>
            <div v-if="item.current_gangway == 'easypay'" @click="edit(item)">修改</div>
          </van-grid-item>
          <van-grid-item v-if="item.merchant_status == 1">
            <span>已审核</span>
            <div v-if="item.current_gangway == 'easypay'" @click="edit(item)">修改</div>
          </van-grid-item>
          <van-grid-item v-if="item.merchant_status == 0">审核中</van-grid-item>
        </van-grid>
      </van-cell>
    </van-list>
    <!-- 列表 end-->
  </div>
</template>

<script>
import Vue from "vue";
import { List, Grid, GridItem } from "vant";
import VueCookie from "vue-cookies";

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(List);

export default {
  name: "MerchantList",
  data() {
    return {
      list: [],
      page: 1,
      limit: 20,
      loading: false,
      finished: false,
      active: 0,
      keyword: "",
    };
  },
  methods: {
    edit(item) {
      console.log(item);
      // this.$router.push({
      //   path: "/MerchantEdit",
      //   query: { id: item.merchant_id },
      // });
      if (item.current_gangway == "easypay") {
        this.$router.push({
          path: "/MerchantEdit",
          query: { id: item.merchant_id },
        });
      } else if (item.current_gangway == "zhongfu") {
        this.$router.push({
          path: "/MerchantEditZhongfu",
          query: { id: item.merchant_id },
        });
      }
    },
    onSearch(v) {
      this.keyword = v;
      this.list = [];
      this.page = 1;
      this.init();
    },
    onCancel() {
      this.keyword = "";
      this.page = 1;
      this.list = [];
      this.init();
    },
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/SalesmanHome");
    },
    init() {
      var that = this;
      var salesman_id = window.localStorage.getItem("salesman_id");
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      console.log(this.$http);
      this.$http
        .get("/wechat/api.salesman/merchantList", {
          params: {
            page: that.page,
            limit: that.limit,
            keyword: this.keyword,
          },
        })
        .then((response) => {
          // 加载状态结束
          that.loading = false;
          // console.log(response.data.data)
          that.list = that.list.concat(response.data.rows);
          // 页码
          that.page++;
          // this.finished = true;
          if (response.data.total < that.limit) {
            that.finished = true;
          }
        });
    },
    merchant_info(id) {
      this.$router.push("/MerchantInfo/" + id);
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>